import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { useNavigate } from "react-router-dom";

/* ================= DEFAULT RACING GAMES ================= */
const DEFAULT_RACING_GAMES = [
  {
    id: 1,
    title: "Gear Madness",
    image: "/assets/gamescard/gear-madness.png",
    link: "https://thegameio.ng/gear-madness/",
  },
  { id: 2, title: "Traffic Racer", image: "/assets/gamescard/traffic-racer.png", link: "https://thegameio.ng/traffic-racer/", },
  { id: 3, title: "Aero Rush", image: "/assets/gamescard/aero-rush.png" },
  { id: 4, title: "Formula Rush", image: "/assets/gamescard/formula-rush.png",link: "https://thegameio.ng/formula-racing/",},
  { id: 5, title: "Roadmash Car", image: "/assets/gamescard/roadmash22.png",link: "https://thegameio.ng/roadmash-car/" },
  { id: 6, title: "Fastlanego", image: "/assets/gamescard/fast-lane.png" },
];

/* ================= COMPONENT ================= */
const RacingGames = () => {
  const navigate = useNavigate();

  // ✅ SAME LOGIN CHECK AS TRENDING
  const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";

  // ✅ SAME CLICK HANDLER AS TRENDING
  const handleGameClick = (game) => {
    if (!isLoggedIn) {
      navigate("/games");
      return;
    }

    if (game.link) {
      // external game (Trending jaisa)
      window.open(game.link, "_self", "noopener,noreferrer");
    } else {
      // default internal page
      navigate("/games");
    }
  };

  return (
    <div className="first-games-slider mt-[50px] sm:mt-0 md:mt-5 lg:mt-5 xl:mt-5">
      <div className="w-full py-0 sm:py-10 md:py-10 lg:py-10 xl:py-10 px-4">
        <div className="max-w-6xl mx-auto">

          {/* ================= HEADER ================= */}
          <div className="flex flex-wrap justify-between items-center mb-8 gap-4">
            <p className="text-white font-[Open Sans] text-[22px] sm:text-[25px] md:text-3xl font-semibold uppercase">
              Racing
            </p>

            <div className="flex items-center gap-3">
              <button
                onClick={() => navigate("/games")}
                className="btn-hover bg-[#3a3f5c] text-white px-4 sm:px-6 py-2 rounded-lg text-sm sm:text-base"
              >
                <span>View All</span>
              </button>

              <button className="swiper-button-prev-racing btn-hover bg-[#3a3f5c] w-10 h-10 sm:w-12 sm:h-10 rounded-lg flex items-center justify-center">
                <span><IoIosArrowBack size={18} color="#fff" /></span>
              </button>

              <button className="swiper-button-next-racing btn-hover bg-[#3a3f5c] w-10 h-10 sm:w-12 sm:h-10 rounded-lg flex items-center justify-center">
                <span><IoIosArrowForward size={18} color="#fff" /></span>
              </button>
            </div>
          </div>

          {/* ================= SLIDER ================= */}
          <Swiper
            modules={[Navigation, Autoplay]}
            navigation={{
              prevEl: ".swiper-button-prev-racing",
              nextEl: ".swiper-button-next-racing",
            }}
            autoplay={{ delay: 3500, disableOnInteraction: false }}
            loop
            spaceBetween={20}
            breakpoints={{
              0: { slidesPerView: 2, spaceBetween: 10 },
              480: { slidesPerView: 2, spaceBetween: 12 },
              640: { slidesPerView: 3, spaceBetween: 16 },
              768: { slidesPerView: 3, spaceBetween: 20 },
              1024: { slidesPerView: 4, spaceBetween: 20 },
              1280: { slidesPerView: 5, spaceBetween: 20 },
            }}
            className="trending-swiper"
          >
            {DEFAULT_RACING_GAMES.map((game) => (
              <SwiperSlide key={game.id}>
                <div
                  className="group cursor-pointer flex flex-col h-full"
                  onClick={() => handleGameClick(game)}
                >
                  {/* CARD */}
                  <div className="rounded-xl border border-gray-800 hover:border-yellow-500 transition-all duration-300 bg-[#0f0f18] overflow-hidden">

                    {/* IMAGE FIX – NO CROP */}
                    <div
                      className="
                        w-full
                        h-[120px]
                        sm:h-[160px]
                        md:h-[180px]
                        lg:h-[200px]
                        flex
                        items-center
                        justify-center
                        bg-black
                      "
                    >
                      <img
                        src={game.image}
                        alt={game.title}
                        className="
                          max-w-full
                          max-h-full
                          object-fill
                          transition-transform
                          duration-500
                          group-hover:scale-105
                        "
                      />
                    </div>
                  </div>

                  {/* TITLE */}
                  <h3 className="text-white font-[Roboto Mono] text-sm sm:text-base md:text-lg font-semibold mt-4 text-center">
                    {game.title}
                  </h3>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

        </div>
      </div>

      {/* ================= BTN-HOVER STYLE ================= */}
      <style>{`
        .btn-hover {
          position: relative;
          overflow: hidden;
        }
        .btn-hover::before,
        .btn-hover::after {
          content: "";
          position: absolute;
          left: 0;
          width: 100%;
          height: 50%;
          background: #249f22;
          transform: scaleX(0);
          transition: transform 0.35s ease;
          z-index: 0;
          pointer-events: none;
        }
        .btn-hover::before {
          top: 0;
          transform-origin: left;
        }
        .btn-hover::after {
          bottom: 0;
          transform-origin: right;
        }
        .btn-hover:hover::before,
        .btn-hover:hover::after {
          transform: scaleX(1);
        }
        .btn-hover span {
          position: relative;
          z-index: 1;
        }
      `}</style>
    </div>
  );
};

export default RacingGames;
